import { DragEvent, forwardRef, MouseEvent, MouseEventHandler, ReactNode } from "react";
import CSS from "./CardContainer.module.css";
import { cardContainerPresetType } from "./CardContainer.interface";

interface cardContainerPropsInterface{
    children?: ReactNode;
    class_name_list?: string[];

    noPadding?: boolean;
    noStyle?: boolean;
    noRadius?: boolean;

    preset?: cardContainerPresetType;

    is_highlight?: boolean;

    onClick?: MouseEventHandler<HTMLDivElement>;
    onDragEnter?: (event: DragEvent<HTMLDivElement>) => void;
    onDragLeave?: (event: DragEvent<HTMLDivElement>) => void;
    onDragOver?: (event: DragEvent<HTMLDivElement>) => void;
    onDrop?: (event: DragEvent<HTMLDivElement>) => void;
}

const CardContainer = forwardRef<HTMLDivElement, cardContainerPropsInterface>((
    {
        children ,
        class_name_list ,

        noPadding ,
        noStyle ,
        noRadius ,

        preset ,

        is_highlight ,

        onClick ,
        onDragEnter ,
        onDragLeave ,
        onDragOver ,
        onDrop ,
    }, ref
) => {

    const _className = [
        CSS.CardContainer,
        onClick && "g_click_event_item",
        ...(class_name_list || []),
        CSS.l_card_container_main,
        noPadding && CSS.noPadding,
        noStyle && CSS.noStyle,
        noRadius && CSS.noRadius,
        preset && CSS.preset,
        preset && CSS[preset],
        is_highlight && CSS.highlight,
    ].filter((className): className is string => Boolean(className)).join(" ");

    const onClickHander = (event: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => {
        // Overlay컴포넌트에서 배경이나 헤더바 외에 다른영역 클릭시 클릭 이벤트 전파에의해서 닫힘 이벤트가 동작하는것을 막기위함
        // event.stopPropagation();

        if(onClick){
            onClick(event);
        }
    }

    return(
        <div
            className={_className}
            onClick={onClickHander}
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            onDragOver={onDragOver}
            onDrop={onDrop}
            ref={ref}
        >
            {children}
        </div>
    )
})

export default CardContainer;